//@vendors
const { get } = require('lodash/object');
const { APIPost } = require('utilities/APIRequestHelper');
const { cookies } = require('utilities/storage');
const { createActions } = require('redux-actions');
// @core
const { cookiesDomain } = require('core/environmentConfig');
//@constants
const {
    segmentedType: { EASY_LOAN_ID, RETAIL_LOAN_ID, CARD_LOAN_ID },
    LOANS_SUBTYPE: { TYPE_C },
    segmentedStatuses: { STATUS_SEGMENTED } } = require('../loansConstants/index');
// @actions
const easyLoanActions = require('./contractEasyLoan');
const retailLoanActions = require('./contractRetailLoan');
const easyLoanTypeCActions = require('./contractEasyLoanTypeC');
const easyLoanInitActions = require('./commons/contractInit');

const simpleActions = createActions(
    'SEGMENTED_LOAN_PRODUCTS',
    'SEGMENTED_LOAN_PRODUCTS_ERROR',
    'SEGMENTED_LOAN_PRODUCTS_ERROR_COUNT',
    'SEGMENTED_LOAN_PRODUCTS_RESET',
    'SEGMENTED_LOAN_PRODUCTS_SUCCESS',
    'SEGMENTED_LOAN_RETAIL_SUCCESS',
    'SAVE_EASY_LOAN_TYPE',
    'SAVE_CARD_LOAN_TYPE'
);

const {
    NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES,
    NOT_ALLOWED_PREAPROVED_CARDS_WAFFER_COUNTRIES
} = require('constants/flagBasedFeatures');
const { getLoanRecordStatus } = require('./loanRecordStatus');

const getSegmentedLoanProducts = () => (dispatch, getState) => {
    const success = getState().segmentedLoanProducts.get('success');
    const isFetching = getState().segmentedLoanProducts.get('isFetching');
    const errorCount = getState().segmentedLoanProducts.get('errorCount');
    const immContractTypeCLoan = getState().contractEasyLoanTypeC;
    const immContractInitLoan = getState().contractInit
    const hasEasyLoanSuccess = immContractTypeCLoan.get('hasEasyLoanSuccess')
    const hasEasyLoanInitSuccess = immContractInitLoan.get('hasEasyLoanSuccess')
    const featureFlagCardSegmented = getState().flagBasedFeatures.get(NOT_ALLOWED_PREAPROVED_CARDS_WAFFER_COUNTRIES);
    const isTypeCLoan = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES);
    const findLoan = (loan, id) => get(loan, 'indicador.id') === id && get(loan, 'indicador.estado') === STATUS_SEGMENTED;
    dispatch(getLoanRecordStatus());
    if (!isFetching && !success && errorCount <= 5) {
        dispatch(simpleActions.segmentedLoanProducts());
        APIPost({ dispatch, endpoint: 'segmentedActiveProducts' })
            .then(response => {
                const loansList = get(response, 'productoActivoSegmentado', []);
                const easyLoan = loansList.find(loan => findLoan(loan, EASY_LOAN_ID));
                const retailLoan = loansList.find(loan => findLoan(loan, RETAIL_LOAN_ID));
                const cardLoan = loansList.find(loan => findLoan(loan, CARD_LOAN_ID));
                if (easyLoan) {

                    if (get(easyLoan, 'informacion.subtipo') === TYPE_C && isTypeCLoan) {

                        !hasEasyLoanInitSuccess && dispatch(easyLoanInitActions.preFillContractEasyLoan(get(easyLoan, 'informacion', {})));
                        !hasEasyLoanSuccess && dispatch(easyLoanTypeCActions.preFillContractEasyLoan(get(easyLoan, 'informacion', {})));
                        dispatch(easyLoanTypeCActions.simpleActions.contractShowTypeC(get(easyLoan, 'informacion', {})));
                    }
                    else if (get(easyLoan, 'informacion.subtipo') !== TYPE_C) {

                        dispatch(easyLoanActions.preFillContractEasyLoan(get(easyLoan, 'informacion', {})));
                    }
                    else {
                        dispatch(easyLoanActions.simpleActions.contractEasyLoanNotAvailable());
                        dispatch(easyLoanTypeCActions.simpleActions.contractEasyLoanNotAvailable());
                    }
                } else {
                    dispatch(easyLoanActions.simpleActions.contractEasyLoanNotAvailable());
                    dispatch(easyLoanTypeCActions.simpleActions.contractEasyLoanNotAvailable());
                }

                if (retailLoan) {
                    dispatch(simpleActions.segmentedLoanRetailSuccess());
                    dispatch(retailLoanActions.getInfoProducts(retailLoan));
                    cookies.set('rls', true)
                } else {
                    cookies.remove('rls', { domain: cookiesDomain })
                    dispatch(retailLoanActions.simpleActions.retailLoanNotAvailable());
                }

                if (easyLoan) {
                    const tipo = get(easyLoan, 'informacion.tipo');
                    dispatch(simpleActions.saveEasyLoanType(tipo));
                } else if (cardLoan) {
                    const tipo = get(cardLoan, 'informacion.tipo');
                    dispatch(simpleActions.saveCardLoanType(tipo));
                }

                dispatch(simpleActions.segmentedLoanProductsSuccess());
            })
            .catch(response => {
                dispatch(simpleActions.segmentedLoanProductsErrorCount());
                if (!!response.error) {
                    dispatch(simpleActions.segmentedLoanProductsError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

module.exports = {
    simpleActions,
    getSegmentedLoanProducts
};
